function Cameroon({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_829)">
        <path d="M22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5069 0 11.147 0.5705 9.04353 1.58763L7.65222 16L9.04353 30.4124C11.147 31.4295 13.5069 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z" fill="#D80027"/>
        <path d="M15.9998 10.4348L17.3811 14.686H21.8516L18.2351 17.3138L19.6164 21.5652L15.9998 18.9376L12.3833 21.5652L13.7648 17.3138L10.1483 14.686H14.6185L15.9998 10.4348Z" fill="#FFDA44"/>
        <path d="M9.0435 1.58813C3.69163 4.17601 0 9.65657 0 15.9999C0 22.3433 3.69163 27.8239 9.0435 30.4117V1.58813Z" fill="#496E2D"/>
        <path d="M22.9565 1.58813V30.4117C28.3084 27.8239 32 22.3433 32 15.9999C32 9.65663 28.3084 4.17601 22.9565 1.58813Z" fill="#FFDA44"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Cameroon;
